/**
 * Static featured / premade trip data.
 * Each trip drives a card on the homepage and a dedicated landing page.
 */

const FEATURED_TRIPS = [
    {
        slug: 'tokyo-food',
        title: 'Tokyo Adventure',
        tagline: 'Neon lights & ancient temples',
        destination: 'Tokyo',
        destinationCode: 'NRT',
        duration: '5 nights',
        startingPrice: 1350,
        currency: 'USD',
        match: 94,
        categories: ['culture', 'adventure', 'city'],
        image: 'https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?w=600&h=400&fit=crop&q=80',
        quickInfo: {
            season: 'Spring (Mar–May) & Autumn (Sep–Nov)',
            transport: 'Direct flights 12–14h from US & Europe',
            budget: 'Mid-range to luxury — great value dining',
            stay: 'City hotels, capsules & ryokan guesthouses',
        },
        gallery: [
            // wide (row1 left)
            'https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?w=900&h=520&fit=crop&q=80',
            // square (row1 right) — Senso-ji
            'https://images.unsplash.com/photo-1528360983277-13d401cdc186?w=500&h=520&fit=crop&q=80',
            // activity (row2 left) — Tsukiji market
            'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=500&h=400&fit=crop&q=80',
            // detail center (row2 mid) — ramen bowl
            'https://images.unsplash.com/photo-1569050467447-ce54b3bbc37d?w=500&h=400&fit=crop&q=80',
            // neighborhood (row2 right) — Harajuku/Kabukicho
            'https://images.unsplash.com/photo-1542051841857-5f90071e7989?w=500&h=400&fit=crop&q=80',
            // panoramic (row3) — Mt Fuji / Tokyo bay
            'https://images.unsplash.com/photo-1536098561742-ca998e48cbcc?w=1200&h=480&fit=crop&q=80',
        ],
        highlights: ['Shibuya Crossing & Harajuku', 'Senso-ji Temple in Asakusa', 'Tsukiji Outer Market food tour', 'Day trip to Mount Fuji', 'Akihabara tech & anime district'],
        itinerary: [
            { day: 1, title: 'Arrive & Explore Shinjuku', description: 'Check into your hotel, stroll through Shinjuku Gyoen garden, and enjoy an evening walk through Kabukicho.' },
            { day: 2, title: 'Temples & Tradition', description: 'Visit Senso-ji in Asakusa, wander through Ueno Park, then head to Akihabara for electronics and anime culture.' },
            { day: 3, title: 'Harajuku & Shibuya', description: 'Explore Meiji Shrine, Takeshita Street fashion, and cross the iconic Shibuya Scramble.' },
            { day: 4, title: 'Day Trip to Hakone', description: 'Take the Romance Car to Hakone for hot springs, Lake Ashi cruise, and views of Mount Fuji.' },
            { day: 5, title: 'Food & Farewell', description: 'Morning at Tsukiji Outer Market, afternoon shopping in Ginza, farewell dinner in Roppongi.' },
        ],
        flightQuery: 'Find flights to Tokyo next month',
        hotelQuery: 'Find hotels in Tokyo for 5 nights next month',
    },
    {
        slug: 'paris-romance',
        title: 'Paris City Break',
        tagline: 'Art, bistros & the Eiffel Tower',
        destination: 'Paris',
        destinationCode: 'CDG',
        duration: '4 nights',
        startingPrice: 980,
        currency: 'USD',
        match: 91,
        categories: ['culture', 'city', 'luxury'],
        image: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=600&h=400&fit=crop&q=80',
        quickInfo: {
            season: 'Spring (Apr–Jun) & Autumn (Sep–Oct)',
            transport: 'Direct flights from most major cities worldwide',
            budget: 'Mid-range — from cozy bistros to fine dining',
            stay: 'Boutique hotels & charming Airbnb apartments',
        },
        gallery: [
            // wide (row1 left) — Eiffel Tower
            'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=900&h=520&fit=crop&q=80',
            // square (row1 right) — Seine / Notre Dame
            'https://images.unsplash.com/photo-1499856871958-5b9627545d1a?w=500&h=520&fit=crop&q=80',
            // activity (row2 left) — Louvre pyramid
            'https://images.unsplash.com/photo-1565799888715-e82e39a09de4?w=500&h=400&fit=crop&q=80',
            // detail center (row2 mid) — French pastries / café
            'https://images.unsplash.com/photo-1533900298318-6b8da08a523e?w=500&h=400&fit=crop&q=80',
            // neighborhood (row2 right) — Montmartre street
            'https://images.unsplash.com/photo-1526676037777-05a232554f77?w=500&h=400&fit=crop&q=80',
            // panoramic (row3) — Paris aerial at dusk
            'https://images.unsplash.com/photo-1431274172761-fca41d930114?w=1200&h=480&fit=crop&q=80',
        ],
        highlights: ['Eiffel Tower at sunset', 'Louvre Museum masterpieces', 'Montmartre & Sacré-Cœur', 'Seine river dinner cruise', 'Le Marais café hopping'],
        itinerary: [
            { day: 1, title: 'Arrival & Left Bank', description: 'Check in near Saint-Germain-des-Prés. Walk along the Seine, visit Shakespeare & Company, dinner at a classic bistro.' },
            { day: 2, title: 'Museums & Monuments', description: 'Morning at the Louvre, afternoon at Musée d\'Orsay, evening at the Eiffel Tower.' },
            { day: 3, title: 'Montmartre & Le Marais', description: 'Climb to Sacré-Cœur, explore artists\' square, then head to Le Marais for vintage shops and falafel.' },
            { day: 4, title: 'Versailles & Farewell', description: 'Day trip to the Palace of Versailles, farewell Seine river cruise at sunset.' },
        ],
        flightQuery: 'Find flights to Paris next month',
        hotelQuery: 'Find hotels in Paris for 4 nights next month',
    },
    {
        slug: 'dubai-luxury',
        title: 'Dubai Luxury Getaway',
        tagline: 'Towers, deserts & lavish nights',
        destination: 'Dubai',
        destinationCode: 'DXB',
        duration: '4 nights',
        startingPrice: 1600,
        currency: 'USD',
        match: 88,
        categories: ['luxury', 'beach', 'city'],
        image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=600&h=400&fit=crop&q=80',
        quickInfo: {
            season: 'Oct–Apr for perfect beach weather',
            transport: 'Emirates hub — direct from 160+ cities',
            budget: 'Luxury-focused with premium dining & experiences',
            stay: 'World-class hotels, beach resorts & sky villas',
        },
        gallery: [
            // wide (row1 left) — Burj Khalifa / downtown
            'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=900&h=520&fit=crop&q=80',
            // square (row1 right) — Dubai Frame / skyline
            'https://images.unsplash.com/photo-1582672060674-bc2bd808a8b5?w=500&h=520&fit=crop&q=80',
            // activity (row2 left) — desert safari dunes
            'https://images.unsplash.com/photo-1509316785289-025f5b846b35?w=500&h=400&fit=crop&q=80',
            // detail center (row2 mid) — spice souk / gold
            'https://images.unsplash.com/photo-1559592413-7cec4d0cae2b?w=500&h=400&fit=crop&q=80',
            // neighborhood (row2 right) — Marina at night
            'https://images.unsplash.com/photo-1526495124232-a04e1849168c?w=500&h=400&fit=crop&q=80',
            // panoramic (row3) — Palm Jumeirah aerial
            'https://images.unsplash.com/photo-1548550023-2bdb3c5beed7?w=1200&h=480&fit=crop&q=80',
        ],
        highlights: ['Burj Khalifa observation deck', 'Desert safari with BBQ dinner', 'Dubai Mall & Aquarium', 'Palm Jumeirah beach day', 'Gold & Spice Souks'],
        itinerary: [
            { day: 1, title: 'Arrive & Downtown Dubai', description: 'Check into your hotel, visit the Dubai Mall, watch the fountain show beneath the Burj Khalifa.' },
            { day: 2, title: 'Desert Safari', description: 'Morning at leisure by the pool, afternoon dune bashing, camel rides, and BBQ dinner under the stars.' },
            { day: 3, title: 'Old & New Dubai', description: 'Explore the Gold and Spice Souks, take an abra across Dubai Creek, then visit the Museum of the Future.' },
            { day: 4, title: 'Beach & Departure', description: 'Relax at Palm Jumeirah beach, brunch at Atlantis, and evening departure.' },
        ],
        flightQuery: 'Find flights to Dubai next month',
        hotelQuery: 'Find hotels in Dubai for 4 nights next month',
    },
    {
        slug: 'barcelona-food',
        title: 'Barcelona Beach & Culture',
        tagline: 'Gaudí, tapas & Mediterranean sun',
        destination: 'Barcelona',
        destinationCode: 'BCN',
        duration: '5 nights',
        startingPrice: 890,
        currency: 'USD',
        match: 92,
        categories: ['beach', 'culture', 'city'],
        image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&h=400&fit=crop&q=80',
        quickInfo: {
            season: 'May–Jun & September are ideal',
            transport: 'Short hops from Europe; cruise port city',
            budget: 'Affordable — tapas, markets & free beaches',
            stay: 'Boutique stays in Gothic Quarter or Eixample',
        },
        gallery: [
            // wide (row1 left) — Sagrada Família
            'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=900&h=520&fit=crop&q=80',
            // square (row1 right) — Park Güell mosaic
            'https://images.unsplash.com/photo-1539037116277-4db20889f2d4?w=500&h=520&fit=crop&q=80',
            // activity (row2 left) — La Boqueria market
            'https://images.unsplash.com/photo-1555992336-03a23c7b20ee?w=500&h=400&fit=crop&q=80',
            // detail center (row2 mid) — tapas platter
            'https://images.unsplash.com/photo-1510693206972-df098062cb71?w=500&h=400&fit=crop&q=80',
            // neighborhood (row2 right) — Gothic Quarter alley
            'https://images.unsplash.com/photo-1523531294919-4bcd7c65e216?w=500&h=400&fit=crop&q=80',
            // panoramic (row3) — Barcelona rooftops / Barceloneta
            'https://images.unsplash.com/photo-1464790719320-516ecd75af6c?w=1200&h=480&fit=crop&q=80',
        ],
        highlights: ['Sagrada Família interior tour', 'Park Güell panoramic views', 'La Boqueria market tasting', 'Barceloneta beach & seafood', 'Gothic Quarter night walk'],
        itinerary: [
            { day: 1, title: 'Gothic Quarter', description: 'Arrive and wander the narrow streets of the Barri Gòtic, dinner on Plaça Reial.' },
            { day: 2, title: 'Gaudí Day', description: 'Morning at Sagrada Família, afternoon at Park Güell, evening stroll on Passeig de Gràcia.' },
            { day: 3, title: 'Food & Markets', description: 'La Boqueria market breakfast, cooking class, tapas crawl through El Born.' },
            { day: 4, title: 'Beach & Waterfront', description: 'Barceloneta beach morning, paella lunch at the port, Montjuïc cable car for sunset views.' },
            { day: 5, title: 'Day Trip & Farewell', description: 'Half-day trip to Montserrat monastery, afternoon souvenir shopping, farewell dinner.' },
        ],
        flightQuery: 'Find flights to Barcelona next month',
        hotelQuery: 'Find hotels in Barcelona for 5 nights next month',
    },
    {
        slug: 'bali-beach',
        title: 'Bali Island Retreat',
        tagline: 'Rice terraces & temple sunsets',
        destination: 'Bali',
        destinationCode: 'DPS',
        duration: '6 nights',
        startingPrice: 1100,
        currency: 'USD',
        match: 96,
        categories: ['beach', 'adventure', 'culture'],
        image: 'https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=600&h=400&fit=crop&q=80',
        quickInfo: {
            season: 'May–Sep for dry, sunny weather',
            transport: 'Flights via Singapore, KL or Hong Kong',
            budget: 'Great value — villas for every budget',
            stay: 'Private villas, eco-resorts & beach clubs',
        },
        gallery: [
            // wide (row1 left) — rice terraces Tegallalang
            'https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=900&h=520&fit=crop&q=80',
            // square (row1 right) — Uluwatu temple clifftop
            'https://images.unsplash.com/photo-1604999333679-b86d54738315?w=500&h=520&fit=crop&q=80',
            // activity (row2 left) — surfing / Kuta beach
            'https://images.unsplash.com/photo-1520454974749-a8b338df2b04?w=500&h=400&fit=crop&q=80',
            // detail center (row2 mid) — Balinese offering / flowers
            'https://images.unsplash.com/photo-1573790387438-4da905039392?w=500&h=400&fit=crop&q=80',
            // neighborhood (row2 right) — Ubud market street
            'https://images.unsplash.com/photo-1518548419970-58e3b4079ab2?w=500&h=400&fit=crop&q=80',
            // panoramic (row3) — Bali jungle / infinity pool
            'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1200&h=480&fit=crop&q=80',
        ],
        highlights: ['Tegallalang rice terraces', 'Uluwatu Temple sunset & Kecak dance', 'Ubud Monkey Forest', 'Seminyak beach clubs', 'Mount Batur sunrise trek'],
        itinerary: [
            { day: 1, title: 'Arrive in Seminyak', description: 'Check in, beach sunset, welcome dinner at a beachfront restaurant.' },
            { day: 2, title: 'Ubud Culture', description: 'Drive to Ubud, visit the Monkey Forest, explore art galleries, and walk the rice terraces.' },
            { day: 3, title: 'Mount Batur Sunrise', description: 'Pre-dawn trek to Mount Batur summit for sunrise, afternoon spa treatment.' },
            { day: 4, title: 'Temples & Waterfalls', description: 'Visit Tirta Empul water temple and Tegenungan waterfall, cooking class in the evening.' },
            { day: 5, title: 'Uluwatu & The South', description: 'Uluwatu Temple clifftop views, Kecak fire dance at sunset, seafood dinner at Jimbaran Bay.' },
            { day: 6, title: 'Beach Day & Departure', description: 'Relax at a Seminyak beach club, last-minute shopping, evening departure.' },
        ],
        flightQuery: 'Find flights to Bali next month',
        hotelQuery: 'Find hotels in Bali for 6 nights next month',
    },
    {
        slug: 'new-york-city-break',
        title: 'New York Highlights',
        tagline: 'Broadway, Brooklyn & beyond',
        destination: 'New York',
        destinationCode: 'JFK',
        duration: '4 nights',
        startingPrice: 750,
        currency: 'USD',
        match: 89,
        categories: ['city', 'culture'],
        image: 'https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?w=600&h=400&fit=crop&q=80',
        quickInfo: {
            season: 'Sep–Nov & Apr–Jun are the sweet spots',
            transport: 'Direct flights to JFK, EWR or LGA',
            budget: 'Wide range — budget to ultra-luxury',
            stay: 'Midtown hotels & boutique Brooklyn stays',
        },
        gallery: [
            // wide (row1 left) — Manhattan skyline / Brooklyn Bridge
            'https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?w=900&h=520&fit=crop&q=80',
            // square (row1 right) — Times Square at night
            'https://images.unsplash.com/photo-1534430480872-3498386e7856?w=500&h=520&fit=crop&q=80',
            // activity (row2 left) — Central Park fall
            'https://images.unsplash.com/photo-1568515387631-8b650bbcdb90?w=500&h=400&fit=crop&q=80',
            // detail center (row2 mid) — yellow cabs / street
            'https://images.unsplash.com/photo-1485871981521-5b1fd3805eee?w=500&h=400&fit=crop&q=80',
            // neighborhood (row2 right) — Brooklyn brownstones
            'https://images.unsplash.com/photo-1522083165195-3424ed129620?w=500&h=400&fit=crop&q=80',
            // panoramic (row3) — NYC aerial / Hudson River
            'https://images.unsplash.com/photo-1546436836-07a91091f160?w=1200&h=480&fit=crop&q=80',
        ],
        highlights: ['Statue of Liberty & Ellis Island', 'Central Park bike ride', 'Broadway show', 'Brooklyn Bridge walk', 'Times Square & 5th Avenue'],
        itinerary: [
            { day: 1, title: 'Manhattan Arrival', description: 'Check in near Midtown, walk to Times Square and Rockefeller Center, dinner in Hell\'s Kitchen.' },
            { day: 2, title: 'Iconic Landmarks', description: 'Ferry to Statue of Liberty, 9/11 Memorial, Wall Street, walk across the Brooklyn Bridge.' },
            { day: 3, title: 'Culture & Parks', description: 'Morning in Central Park, afternoon at the Met, evening Broadway show.' },
            { day: 4, title: 'Brooklyn & Farewell', description: 'Brunch in Williamsburg, explore DUMBO, farewell dinner at a Lower East Side speakeasy.' },
        ],
        flightQuery: 'Find flights to New York next month',
        hotelQuery: 'Find hotels in New York for 4 nights next month',
    },
];

export default FEATURED_TRIPS;
